import { styled } from "../stitches.config";
export const Heading = styled("h1", {
    textAlign: "center",
    fontsize: "$2",
    color: "$text",
});
